import './DemoLabel.scss';

const ENVIRONMENT_LABELS = {
  'dev.watchid.rolex.com': 'DEV ENV',
  'ci.watchid.rolex.com': 'TEST ENV',
  'pp.watchid.rolex.com': 'PPROD',
};

const LOCAL_HOSTNAMES = new Set(['localhost', '127.0.0.1', '::1', '[::1]']);
const PRODUCTION_HOSTNAME = 'watchid.rolex.com';

const getHostname = () => {
  if (typeof window === 'undefined') {
    return '';
  }

  return window.location.hostname;
};

const getEnvironmentLabel = (hostname) => {
  if (LOCAL_HOSTNAMES.has(hostname)) {
    return 'LOCAL ENV';
  }

  return ENVIRONMENT_LABELS[hostname] || '';
};

const DemoLabel = () => {
  const hostname = getHostname();

  if (hostname === PRODUCTION_HOSTNAME) {
    return null;
  }

  const environmentLabel = getEnvironmentLabel(hostname);

  return (
    <div className="demo">FOR TESTING PURPOSE ONLY ({environmentLabel})</div>
  );
};

export default DemoLabel;
